import React from 'react';

/* 정부지원사업 분류 체계 — fphub 「전체 지원금 지도」와 같은 한 벌 (지도사 2026-09-25 · 2026-10-01 「기타 › 기업 인증」 추가)
 *   대분류 5(제품개발 · 생산 · 고용 · 마케팅 · 기타) + 세부 15, 정책자금 4 · 전용분야 2
 *   애매한 공고는 대분류만 골라도 된다 — 매칭 엔진(govMatch.js TAXONOMY)이 대분류를 그 아래 세부 전부로 본다.
 *   옛 라벨(고용지원금 · 마케팅 지원 …)은 엔진 LEGACY_CAT 이 옮기므로 기존 데이터는 그대로 두어도 된다.
 *   「기타」 대분류(noGroupLabel)는 묶음 제목일 뿐 라벨로 저장하지 않는다 — 옛 데이터의 '기타'(= 분류 미정)와 뜻이 달라서.
 *     머리 체크 = 세부(기업 인증) 전부 선택 · 옛 '기타' 값은 「옛 분류」 표시로 남겨 지울 수 있게 한다.
 *   기업 인증(벤처 · 이노비즈 · 메인비즈 · ISO 경영시스템 · 기업부설연구소 · 기업 지정) ≠ 제품 인증(KC · CE · FDA · GS · 성능인증 …) */
export interface GovGroup { k: string; name: string; items: string[]; loan?: boolean; noGroupLabel?: boolean }
export const GOV_TAXONOMY: GovGroup[] = [
  { k: 'dev', name: '제품개발', items: ['R&D', '시제품 제작', '특허 출원', '제품 인증'] },
  { k: 'prod', name: '생산', items: ['공장 안전화', '공장 자동화', '공장 지능화', '전산 프로그램'] },
  { k: 'emp', name: '고용', items: ['고용 창출', '고용 유지'] },
  { k: 'mkt', name: '마케팅', items: ['온라인', '오프라인', '수출', '매장환경 개선'] },
  { k: 'etc', name: '기타', items: ['기업 인증', '물류비', '경영 개선'], noGroupLabel: true },   // 2026-10-08 지도사 「기타에 넣어 국내 물류비」 — 수출 물류비는 수출
  { k: 'loan', name: '정책자금', items: ['직접대출', '대리대출', '이차보전', '보증지원'], loan: true },
];
export const GOV_ARTS = ['예술', '스포츠', '식품', '환경', '문화', '화장품', '농업', '수산', '관광', '반려동물', '물산업', '핀테크', '서점'];
/** 기업 유형 (2026-10-03) — 확인서·지정을 가진 기업만 신청할 수 있는 공고. 분류 칸에 함께 저장(엔진 govMatch.TYPES 와 같음) */
export const GOV_TYPES = ['사회적경제기업', '여성기업', '장애인기업', '뿌리기업', '소부장기업', '공장등록 업체', '대기배출사업장', '매장운영', '농업법인'];
/* ── 업종 → 하위 업종 · 전용 대상 (2026-10-05g 지도사 확정 「추천대로」) ──────────────────────────────────────
 *  엔진(services/govMatch.js PARENTS · SUBS · SHARED · SPECIAL)과 같은 이름 · 순서 — backend 테스트(govMatch.test.js)가 확인한다.
 *  세부업종은 키 'P›S' 로 저장(업종 「무관」 › 세부업종 = '*›S' — 2026-10-05j 부터 이름 전체) — 공고: conditions.subs · 업체: tags(직접 켠 것) + 업종·주요 제품 글 자동 − sectors_off(뺀 것)
 *  화면 글은 「업종 › 세부업종」 한 벌(「제조업 › 해양」 · 「무관 › 해양」 — 2026-10-05q 지도사) · 켜진 업종 · 세부업종 칩은 전부 «하나라도»
 *  전용 대상 = 기업 유형(GOV_TYPES · 분류 칸) + 특수 자격(GOV_SPECIAL_Q · conditions.sec) — «하나라도», 업종 조건과는 «둘 다» */
export const GOV_PARENTS = ['도소매업', '제조업', 'IT/SW개발업', '연구개발업', '서비스업', '건설업', '숙박업', '음식점업', '농림축수산업', '기타'];
export const GOV_SUBS: Record<string, string[]> = {
  '도소매업': ['서점', '무역(수출입)', '전자상거래'],
  '제조업': ['반도체·전자', '이차전지·전기', '자동차·모빌리티', '조선·선박', '항공·드론', '방산', '로봇·자동화', '바이오·제약', '의료기기', '화학·소재', '금속·기계', '섬유·의류', '에너지·신재생', '원전', '방사선', '수소', '소방·안전', '식품', '수산식품', '곡물가공', '전통식품', '전통주', '화장품', '생활소비재', '환경', '물산업', '예술·공예', '반려동물', '에듀테크', '뿌리산업', '고령친화', '해양', '가구', '유아·어린이용품', '농기자재·사료', '건강기능식품', '인쇄', '포장·패키징', '스포츠'],
  'IT/SW개발업': ['AI·데이터', '핀테크·블록체인', '보안', '플랫폼·커머스', '게임', '에듀테크', '메타버스·XR', '고령친화', '의료기기'],
  '연구개발업': ['AI·SW', '바이오·제약', '의료기기', '소재·부품·장비', '전기·전자·반도체', '기계·로봇·모빌리티', '에너지·환경', '농생명·식품', '방산', '해양', '방사선'],
  '서비스업': ['문화·콘텐츠', '예술·공예', '스포츠', '관광', '반려동물', '환경', '물산업', '디자인', '이·미용·생활위생', '물류·운수', '메타버스·XR', '고령친화', '지식서비스', '자동차정비', '의료기관', '사회복지·보육', '교육·학원', '설계·엔지니어링'],
  '건설업': ['소방시설공사', '전기·통신공사'],
  '숙박업': ['관광숙박'],
  '음식점업': [],
  '농림축수산업': ['농업', '축산', '수산', '임업', '전통식품', '전통주'],
  '기타': [],
};
export const SUB_SEP = '›';
export const ANY_PARENT = '*';
/** ◆ 여러 업종 아래 같은 이름으로 있는 분야 — 업종 무관 분야 칸에서 앞쪽에 한 번 (엔진 SHARED) */
export const GOV_SHARED: string[] = (() => { const n: Record<string, number> = {}; const o: string[] = []; GOV_PARENTS.forEach(p => GOV_SUBS[p].forEach(x => { n[x] = (n[x] || 0) + 1; if (n[x] === 2) o.push(x); })); return o; })();
/** 하위 업종 이름 한 벌(표 순서 · 같은 이름은 한 번) — 업종 「무관」 밑 「분야」 = 이 전체 (엔진 SUB_NAMES · 2026-10-05j 지도사 확정) */
export const GOV_SUB_NAMES: string[] = (() => { const o: string[] = []; GOV_PARENTS.forEach(p => GOV_SUBS[p].forEach(x => { if (!o.includes(x)) o.push(x); })); return o; })();
/** 분야 성격 하위 업종 — 공고 글의 「○○ 기업」을 업종 무관 '*›S' 로 쓰는 이름 (엔진 FIELD_SUBS 와 같은 이름 · 순서) */
export const GOV_FIELD_SUBS = ['식품', '화장품', '생활소비재', '스포츠', '문화·콘텐츠', '관광', '핀테크·블록체인', '수산', '해양', '반려동물', '환경', '물산업', '예술·공예', '전통식품', '전통주', '방산', '고령친화', '방사선'];
/** 업종 「무관」 밑 「분야」 칸 — 업종별 묶음 없이 한 줄 목록 (2026-10-05p 지도사 「무관 밑에 이게 왜 또 나와」)
 *  분야 성격 이름(GOV_FIELD_SUBS) · ◆ 여러 업종 공통(GOV_SHARED)이 앞, 나머지 하위 업종 이름은 표 순서(GOV_SUB_NAMES) · 같은 이름은 한 번 */
export const GOV_FIELD_NAMES: string[] = [...GOV_FIELD_SUBS, ...GOV_SHARED, ...GOV_SUB_NAMES].filter((x, i, a) => a.indexOf(x) === i);
/** 특수 자격 — 업체에 체크된 경우만 추천(자동 없음 · 모르면 제외) */
export const GOV_SPECIAL_Q = ['재창업·재도전', '재해 피해기업', '넷제로 유망기업', '사업전환 승인기업', '스마트공장 구축기업', '대기업 협력사', '혁신제품 지정기업', '백년소상공인', '졸업후보기업', '로컬크리에이터', '대학발 창업기업', '연구소 보유기업', '벤처기업', '이노비즈', '메인비즈', '특허 보유', '상표권 보유', '기숙사 임차기업', '농공단지 입주기업', '재단 보증 이용기업', '화장품 관련 제조'];
/** 처음 짓는 키 · 키 풀기 */
export const subKey = (p: string, s: string): string => `${p}${SUB_SEP}${s}`;
/** 하위 업종 옛 이름 → 새 이름 (엔진 SUB_ALIAS · 2026-10-05p 「핀테크」 → 「핀테크·블록체인」) — 저장된 옛 이름 키도 새 키로 읽는다 */
export const SUB_ALIAS: Record<string, string> = { 핀테크: '핀테크·블록체인' };
export function parseSubKey(k: string): { p: string; s: string } | null {
  const i = String(k || '').indexOf(SUB_SEP);
  if (i <= 0) return null;
  const p = k.slice(0, i).trim(), s0 = k.slice(i + 1).trim(), s = SUB_ALIAS[s0] || s0;
  if (p === ANY_PARENT) return GOV_SUB_NAMES.includes(s) ? { p, s } : null;   // 업종 무관 + 하위 업종 이름 아무것이나 (2026-10-05j)
  return GOV_SUBS[p] && GOV_SUBS[p].includes(s) ? { p, s } : null;
}
export const isSubKey = (k: string): boolean => !!parseSubKey(k);
/** 키 정본 — 옛 이름(핀테크)은 새 이름으로 · 모양이 틀리면 그대로 (엔진 canonKey 와 같다 · 2026-10-05p) */
export const canonSubKey = (k: string): string => { const x = parseSubKey(k); return x ? subKey(x.p, x.s) : k; };
/** 옛 키 → 새 키 둘(하나라도) — 엔진 OLD_KEYS 와 같다. 저장된 옛 키(업체 tags · 공고 conditions)는 읽을 때 펼친다
 *  2026-10-05h 「항공·드론·방산」 · 05i 「전통식품·전통주」 · 05m 「바이오·제약·의료기기」(제조업) · 「바이오·의료」(연구개발업) → 「바이오·제약」 + 「의료기기」 */
export const OLD_SUB_KEYS: Record<string, string[]> = {
  '제조업›항공·드론·방산': ['제조업›항공·드론', '제조업›방산'],
  '제조업›전통식품·전통주': ['제조업›전통식품', '제조업›전통주'], '농림축수산업›전통식품·전통주': ['농림축수산업›전통식품', '농림축수산업›전통주'], '*›전통식품·전통주': ['*›전통식품', '*›전통주'],
  '제조업›바이오·제약·의료기기': ['제조업›바이오·제약', '제조업›의료기기'], '*›바이오·제약·의료기기': ['*›바이오·제약', '*›의료기기'], '연구개발업›바이오·의료': ['연구개발업›바이오·제약', '연구개발업›의료기기'],
};
/** 키 목록의 옛 키를 새 키로 펼친다(순서 유지 · 같은 키는 한 번) */
export const expandSubKeys = (keys: string[]): string[] => { const o: string[] = []; keys.forEach(k => (OLD_SUB_KEYS[k] || [canonSubKey(k)]).forEach(x => { if (!o.includes(x)) o.push(x); })); return o; };
/** 같은 이름의 업종 › S 가 있는 «자동 · 옛 값» 무관 › S 를 뺀다 (엔진 dropCoveredFields · 2026-10-05q)
 *  켜진 칩은 전부 하나라도 — 무관 › S 가 업종 › S 보다 넓다. keep(직접 고른 키)은 빼지 않는다 · biz 는 예전 호출 모양 호환용 */
export const dropCoveredFields = (keys: string[], _biz: string[] = [], keep: string[] = []): string[] => {
  const ind = keys.map(k => parseSubKey(k)).filter((x): x is { p: string; s: string } => !!x && x.p !== ANY_PARENT).map(x => x.s);
  if (!ind.length) return keys;
  const kp = keep.map(canonSubKey);
  return keys.filter(k => { const x = parseSubKey(k); return !(x && x.p === ANY_PARENT && ind.includes(x.s) && !kp.includes(canonSubKey(k))); });
};
/** 「또는」 묶음이 모두 세부업종 키(업종 › S · 무관 › S — 섞여도)뿐이면 그 키들(옛 키는 새 키로) — 아니면 null (엔진 tidyTargets 와 같다 · 2026-10-05q 켜진 칩은 전부 하나라도) */
export function anySubKeys(any: unknown): string[] | null {
  if (!Array.isArray(any) || !any.length) return null;
  const out: string[] = [];
  for (const g of any) {
    if (!g || typeof g !== 'object' || Array.isArray(g)) return null;
    const o = g as Record<string, unknown>;
    if (Object.keys(o).some(k => k !== 'subs') || !Array.isArray(o.subs) || !o.subs.length || o.subs.some(x => typeof x !== 'string')) return null;
    for (const k of expandSubKeys(o.subs as string[])) { if (!parseSubKey(k)) return null; if (!out.includes(k)) out.push(k); }
  }
  return out;
}
/** 예전 이름 (2026-10-05n — 업종 키뿐인 묶음) · 지금은 무관 키가 섞여도 펼친다 */
export const anyIndKeys = anySubKeys;
/** 자동 체크 기록(conditions.sec_auto.items)에 있는 키 — 없으면 지도사가 직접 고른 것 (엔진 toRules manual 과 같다) */
const autoRecKeys = (c: unknown): string[] => {
  const a = c && typeof c === 'object' ? (c as { sec_auto?: { items?: unknown } }).sec_auto : null;
  return a && Array.isArray(a.items) ? (a.items as Array<{ k?: unknown }>).map(x => canonSubKey(String(x && x.k || ''))).filter(isSubKey) : [];
};
/** 공고 조건 정리 — 세부업종 키뿐인 「또는」은 subs 로 펼침 · 옛 키 펼치기 · 자동 무관 › S 정리 (양식 불러오기 · 저장 공용 · 엔진 tidyTargets 와 같다)
 *  업종 아닌 조건이 있는 「또는」은 그대로 · 직접 고른 무관 › S(기록 없는 저장 키)는 지우지 않는다 */
export function tidyConditions<T extends { subs?: string[]; any?: unknown }>(c: T, biz: string[] = []): T {
  const flat = anySubKeys(c.any);
  const subs0 = Array.isArray(c.subs) ? c.subs : [];
  const rec = autoRecKeys(c);
  const keep = expandSubKeys(subs0).filter(k => !rec.includes(k));
  const subs = dropCoveredFields(expandSubKeys([...subs0, ...(flat || [])]), biz, keep);
  const next = { ...c } as T;
  if (flat) delete next.any;
  if (subs.length) next.subs = subs; else delete next.subs;
  return next;
}
/** 키 → 화면 글 「제조업 › 식품」 · 「무관 › 수산」 (엔진 subLabel 과 같다 · 2026-10-05q 업종 › 세부업종) · 옛 키는 새 키 둘의 글 */
export const subLabel = (k: string): string => { const x = parseSubKey(k); return x ? (x.p === ANY_PARENT ? `무관 › ${x.s}` : `${x.p} › ${x.s}`) : (OLD_SUB_KEYS[k] ? OLD_SUB_KEYS[k].map(subLabel).join(' · ') : k); };
/** 업종 칩 짧은 이름 */
export const parentShort = (p: string): string => (p === 'IT/SW개발업' ? 'IT/SW' : p === ANY_PARENT ? '무관' : p);
/** 무관 › 세부업종 칩의 뜻 (마우스를 올리면) — 업종 상관없이 그 세부업종 업체 모두 (엔진 fieldsOf 와 같은 기준 · 업종 › 세부업종 칩 뜻 GOV_SUB_INFO 와 다르다) */
const GOV_FIELD_INFO: Record<string, string> = {
  수산: '어업 · 양식 · 수산물 가공 · 수산 유통 모두 (횟집 같은 음식점은 아님)',
  축산: '가축 사육 · 도축 · 식육 가공 · 축산물 유통 모두 (고기 음식점은 아님)',
  농업: '재배 · 농산물 가공 · 유통 · 농자재(비료 · 농약 · 농기계) 모두',
  임업: '임업 · 산림 · 임산물 가공 · 유통 모두',
  스포츠: '스포츠 시설 · 서비스 · 용품 제조 · 유통 모두',
  식품: '식품 제조 · 가공 · 유통 모두 (음식점 · 카페는 아님)',
  화장품: '화장품 제조 · 브랜드 · 유통 모두 (미용실 · 네일은 아님)',
  반려동물: '펫푸드 · 용품 제조 · 판매 · 동물병원 · 미용 · 위탁 모두',
  환경: '환경 설비 제조 · 폐기물 · 재활용 · 수처리 · 환경 컨설팅 모두',
  물산업: '상하수도 · 수처리 · 정수 · 물 기기 제조 · 운영 모두',
  '예술·공예': '공예품 제작 · 예술인 · 예술단체 · 공연 · 전시 모두',
  방산: '방산 부품 · 군수품 제조 · 국방 연구개발 모두',
  전통식품: '장류 · 김치 · 떡 · 한과 등 전통식품 — 만드는 회사 · 농업법인 모두',
  전통주: '전통주 · 막걸리 등 양조 — 양조장 · 농업법인 모두',
  해양: '해양 · 해운 · 항만 · 선용품 · 해양바이오 · 해양레저 · 해양장비 · 해양플랜트 모두 (연구개발이 아니어도)',
  방사선: '방사선 · 방사성 동위원소 · 비파괴검사 · X선 · 감마선 · 전자빔 · 멸균 — 기기 제조 · 연구 · 검사 서비스 모두 (병원 영상의학 진료는 아님)',
  '바이오·제약': '바이오 · 제약 · 의약품 · 백신 · 세포 · 유전자 · 발효 소재 · 건강기능식품 — 제조 · 연구개발 · 유통 모두 (의료기기는 따로)',
  '의료기기': '의료기기 · 의료용 기기 · 진단기기 · 치과 기자재 · 임플란트 · 헬스케어 기기 · 디지털헬스 앱 · 의료 AI(SaMD) — 제조 · 연구개발 · SW · 유통 모두',
  '생활소비재': '생활용품 · 가구 · 주방 · 완구 · 잡화 — 제조 · 유통 모두',
  '문화·콘텐츠': '영상 · 방송 · 게임 · 출판 · 음악 · 웹툰 · 캐릭터 · 공연 기획 모두',
  관광: '여행업 · 관광숙박 · 국제회의(MICE) · 유원시설 · 관광 벤처 모두',
  '핀테크·블록체인': '전자금융 · 간편결제 · 블록체인 · 웹3 · NFT · 크라우드펀딩 · 인슈어테크 모두',
  에듀테크: '교구 · 학습 기기 · 코딩 로봇 제조 · 이러닝 · 온라인 교육 플랫폼 · 학습 앱 · LMS 모두 (오프라인 학원 · 교습소는 아님)',
  // 2026-10-05p 새 하위 업종 · ◆
  뿌리산업: '주조 · 금형 · 사출 · 단조 · 용접 · 표면처리 · 도금 · 열처리 · 소성가공 — 만드는 곳 · 유통 모두',
  고령친화: '고령친화 제품 · 실버 용품 · 복지용구 제조 · 실버 케어 · 돌봄 서비스 · 에이지테크 SW 모두 (시니어 «창업자» 공고는 대표 나이 조건)',
  '메타버스·XR': '메타버스 · XR · VR · AR · 가상융합 · 실감콘텐츠 — 플랫폼 · SW 개발 · 콘텐츠 제작 모두',
  디자인: '산업 · 시각 · 제품 · 포장 · UX/UI · 브랜드 디자인 전문회사 (디자인을 «받는» 지원 공고는 아님)',
  '이·미용·생활위생': '미용실 · 이용원 · 네일 · 피부관리 · 세탁소 · 목욕장 (미용 기기 · 화장품 회사는 아님)',
  '물류·운수': '화물 운송 · 택배 · 창고 · 물류센터 · 포워딩 · 해운 (택시 · 버스 여객은 아님)',
  // 2026-10-05r 등록 공고 본문(「제조업 또는 지식서비스업」 자격)으로 더함
  지식서비스: 'SW · 정보서비스 · 출판 · 영상 · 연구개발 · 엔지니어링 · 설계 · 법무 · 회계 · 세무 · 컨설팅 · 광고 · 디자인 · 교육 서비스 (만드는 곳 · 도소매 · 음식점 · 운송 · 미용 · 숙박은 아님)',
  전자상거래: '온라인 셀러 · 쇼핑몰 운영 · 통신판매업 (온라인 판매가 주업인 업체)',
  자동차정비: '자동차 정비 · 수리 · 카센터 · 폐차업 (부품 제조는 아님)',
  의료기관: '병·의원 · 한의원 · 치과 · 요양병원 · 의료법인 (동물병원은 아님)',
  '사회복지·보육': '사회복지시설 · 어린이집 · 요양원 · 장기요양기관 · 지역아동센터',
  '교육·학원': '학원 · 교습소 · 직업훈련기관 · 평생교육시설 (에듀테크 SW는 IT/SW)',
  '설계·엔지니어링': '엔지니어링 · 건축설계 · 기술사사무소 · 측량 (시공은 건설업)',
  관광숙박: '관광호텔 · 민박 · 펜션 · 여관 · 한옥체험 · 캠핑장',
};
export const fieldTip = (name: string): string => GOV_FIELD_INFO[name] || `업종 상관없이 「${name}」 업체 모두 — 제조 · 유통 · 서비스 · 연구`;
/** 옛 라벨 → 새 키 (엔진 LEGACY_ART · LEGACY_SECTOR 와 같다 — 업체 화면이 옛 체크를 새 칩으로 보여 주려고) */
export const LEGACY_TO_KEYS: Record<string, string[]> = {
  예술: ['*›예술·공예'], 반려동물: ['*›반려동물'], 환경: ['*›환경'], 물산업: ['*›물산업'], 식품: ['제조업›식품'], 화장품: ['제조업›화장품'],
  스포츠: ['서비스업›스포츠'], 문화: ['서비스업›문화·콘텐츠'], 관광: ['서비스업›관광'], 핀테크: ['IT/SW개발업›핀테크·블록체인'], 서점: ['도소매업›서점'],
  농업: ['농림축수산업›농업'], 수산: ['농림축수산업›수산'],
  소방산업체: ['제조업›소방·안전', '건설업›소방시설공사'], '원전·에너지 기업': ['제조업›원전', '제조업›에너지·신재생'], '신재생에너지 기업': ['제조업›에너지·신재생'],
  '수소 기업': ['제조업›수소'], 방산기업: ['*›방산'], '항공·우주 기업': ['제조업›항공·드론'], '조선·해양 기업': ['제조업›조선·선박'],
  '반도체 기업': ['제조업›반도체·전자'], '바이오·제약 기업': ['제조업›바이오·제약', '연구개발업›바이오·제약'], '의료기기 기업': ['제조업›의료기기', '연구개발업›의료기기'],   // 2026-10-05m 제조업 · 연구개발업 공통(하나라도)
  '섬유·패션 기업': ['제조업›섬유·의류'], '소비재 기업': ['제조업›생활소비재', '제조업›식품', '제조업›화장품', '제조업›섬유·의류'],   // 펫 용품 · 사료는 생활소비재 낱말로(엔진 05k)
  '축산 기업': ['농림축수산업›축산'], '전통주 기업': ['*›전통주'], '전통식품 기업': ['*›전통식품'],
};
export const LEGACY_SPECIAL: Record<string, string> = { '재창업·재도전 기업': '재창업·재도전' };
/** 공고 쪽 옛 라벨 → 새 키 (엔진 LEGACY_ART · LEGACY_SECTOR 와 같다) — 업체 쪽(LEGACY_TO_KEYS)과 다른 것: 분야 성격 라벨은 업종 무관('*›S' · 2026-10-05k) */
export const LEGACY_PROGRAM_KEYS: Record<string, string[]> = {
  ...LEGACY_TO_KEYS,
  식품: ['*›식품'], 화장품: ['*›화장품'], 스포츠: ['*›스포츠'], 문화: ['*›문화·콘텐츠'], 관광: ['*›관광'], 핀테크: ['*›핀테크·블록체인'],
  농업: ['농림축수산업›농업', '농림축수산업›축산', '농림축수산업›임업'],
  '소비재 기업': ['*›생활소비재', '*›식품', '*›화장품', '*›섬유·의류'],   // 바이오·제약 기업 · 의료기기 기업은 업체 쪽과 같다(산업 성격 · 두 업종 — 2026-10-05m)
};
/** 옛 제조업 세부 이름 → 키 — 「항공·드론·방산」은 항공·드론 · 방산 둘 다 (2026-10-05h · 엔진 mfgKeys 와 같다) */
export const mfgKeys = (name: string): string[] => (name === '항공·드론·방산' ? ['제조업›항공·드론', '제조업›방산'] : name === '바이오·제약·의료기기' ? ['제조업›바이오·제약', '제조업›의료기기'] : [`제조업›${name}`]);   // 2026-10-05m 바이오·제약·의료기기 → 둘 다
/** 하위 업종 칩의 뜻 (마우스를 올리면) — 업체는 업종·주요 제품 글로 자동 판정 */
export const GOV_SUB_INFO: Record<string, string> = {
  '소방·안전': '소방용품·장비, 방재·안전장비 제조 — 「소방산업체 대상」 공고는 소방시설공사(건설업)와 함께 연결',
  '항공·드론': '항공 부품·정비, 우주·위성, 드론·무인기 제조',
  방산: '◆ 방위산업체·국방 협력·군수품(총포·탄약·화약) — 제조업과 연구개발업 공통 세부업종',
  '바이오·제약': '◆ 바이오·제약·의약품·백신·세포·유전자·발효 소재·건강기능식품 — 제조(제조업) · 연구개발(연구개발업) 공통 세부업종. 의료기기는 「의료기기」',
  '의료기기': '◆ 의료기기·의료용 기기·진단기기·체외진단·치과 기자재·임플란트·헬스케어 기기(제조업 · 연구개발업) · 디지털헬스 앱·의료 AI·SaMD(IT/SW) 공통 세부업종',
  해양: '◆ 선박 부품·조선 기자재·해양플랜트·해양장비·수중·해저·해양바이오 소재·선용품 제조(제조업) · 해양 기술 연구개발(연구개발업) 공통 세부업종. 업종 상관없이 해양 업체 모두는 「무관 › 해양」',
  방사선: '◆ 방사선 기기·차폐재·측정기·비파괴검사 장비 제조(제조업) · 방사선 기술 연구개발(연구개발업) 공통 세부업종. 업종 상관없이 방사선 업체 모두는 「무관 › 방사선」',
  수산식품: '수산물 가공·수산식품 제조(김·어묵·젓갈·건어물·냉동 수산) — 「수산가공품 생산업체」 공고는 식품 전체가 아니라 이 세부업종',
  곡물가공: '곡물(밀 · 쌀 · 콩 · 잡곡)을 원료로 가공하는 제조(제분 · 도정 · 떡 · 면류 · 제과 · 제빵 · 두부) — 「국산밀 가공확대」 「가공용 쌀」 공고는 식품 전체가 아니라 이 키(2026-10-18)',
  원전: '원전 협력·기자재, 원자력 관련 제조',
  수소: '수소 생산·저장·충전 설비, 연료전지',
  식품: '식품·식료품 제조·가공(HACCP · 식품 수출 등). 음식점·카페는 「음식점업」',
  '전통식품': '장류·김치·떡·한과·조청·식초 등 전통식품·전통 발효 — ◆ 직접 만드는 농업법인도', '전통주': '전통주·막걸리·탁주·약주·청주·증류주 양조(주류 제조) — ◆ 직접 빚는 농업법인도',
  화장품: '화장품 제조·브랜드(OEM·ODM·원료). 미용실·네일은 아님',
  생활소비재: '생활용품·가구·주방·완구·잡화·유아용품 등 소비재 제조',
  환경: '◆ 폐기물·재활용·수처리·오염방지 설비(제조) · 환경 컨설팅·처리업(서비스)',
  물산업: '◆ 상하수도·수처리·정수·담수화 — 설비 제조 · 운영 서비스',
  '예술·공예': '◆ 공예품 제작(제조) · 예술인·예술단체·공연·전시(서비스)',
  반려동물: '◆ 펫푸드·용품 제조(제조) · 동물병원·미용·위탁(서비스). 가축은 「농림축수산업 › 축산」',
  '문화·콘텐츠': '영상·방송·게임·출판·음악·웹툰·캐릭터·공연 기획',
  스포츠: '스포츠·체육 시설·서비스·구단 (용품 제조는 「생활소비재」)',
  관광: '여행업·관광숙박·국제회의(MICE)·유원시설·관광 벤처',
  '핀테크·블록체인': '전자금융·간편결제·블록체인·웹3·NFT·크라우드펀딩·인슈어테크',
  'AI·데이터': '인공지능·빅데이터·데이터 가공 솔루션',
  에듀테크: '◆ 교구·학습 기기·교육용 하드웨어·코딩 로봇 제조(제조업) · 이러닝·온라인 교육 플랫폼·학습 앱/솔루션·LMS 개발(IT/SW) 공통 세부업종. 오프라인 학원·교습소는 아님',
  서점: '서점·책방(출판사는 「서비스업 › 문화·콘텐츠」)',
  '무역(수출입)': '무역·수출입·구매대행',
  소방시설공사: '소방시설 공사·설계·감리·점검업',
  '전기·통신공사': '전기공사업 · 정보통신공사업',
  농업: '작물 재배·영농·스마트팜·농업법인',
  축산: '한우·양돈·양계·낙농 등 가축 사육 농가·법인 (축산물 가공·판매는 아님)',
  수산: '어업·양식·어촌 (수산물 가공은 「제조업 › 식품」)',
  임업: '임업·산림 경영·양묘',
  // 2026-10-05p 새 하위 업종 · ◆ (지도사 「2번 반영해줘」)
  뿌리산업: '주조·금형·사출·단조·용접·표면처리·도금·열처리·소성가공 제조 — 업종 글로 자동. 기업 유형 「뿌리기업」(확인서)을 체크한 업체도 이 세부업종으로 봅니다',
  고령친화: '◆ 고령친화 제품·실버 용품·복지용구 제조(제조업) · 실버 케어·돌봄(서비스업) · 에이지테크 SW(IT/SW) 공통 세부업종',
  '메타버스·XR': '◆ 메타버스·XR·VR/AR 플랫폼·엔진 개발(IT/SW) · 실감콘텐츠 제작(서비스업) 공통 세부업종',
  디자인: '전문디자인업 — 산업·시각·제품·포장·UX/UI·브랜드 디자인 회사. 디자인을 «받는» 지원 공고는 아님',
  '이·미용·생활위생': '공중위생업 — 미용실·이용원·네일·피부관리·세탁소·목욕장. 미용 기기·화장품 제조는 아님',
  '물류·운수': '화물 운송·택배·창고·물류센터·포워딩·해운 — 크레탑 「운수창고업」 업체 포함. 택시·버스 여객은 아님',
  // 2026-10-05r 「제조업 또는 지식(기반)서비스업」 자격(등록 공고 78건 — 경기 시군 기업지원 · 울산 · 광주 · 전남 경영안정자금 · 일자리 우수기업)
  지식서비스: '지식서비스산업(산업발전법) — SW·정보서비스·출판·영상·연구개발·엔지니어링·건축설계·법무·회계·세무·컨설팅·광고·디자인·교육 서비스·사업지원. IT/SW개발업·연구개발업 업체는 자동으로 포함. 만드는 곳·도소매·음식점·운송·미용·숙박·부동산·건설 시공은 아님',
  전자상거래: '온라인 셀러·쇼핑몰 운영·통신판매업 — 온라인 판매가 주업인 도소매 업체. 오프라인 매장 판매는 아님',
  자동차정비: '자동차 정비·종합정비·전문정비·카센터·폐차업. 자동차 부품 제조는 제조업 › 자동차·모빌리티',
  의료기관: '병원·의원·한의원·치과·요양병원·의료법인 — 의료기관 대상 공고. 동물병원은 아님',
  '사회복지·보육': '사회복지시설·사회복지법인·어린이집·요양원·장기요양기관·지역아동센터',
  '교육·학원': '교육서비스업 — 학원·교습소·직업훈련기관·평생교육시설. 온라인 교육 SW는 IT/SW개발업 › 에듀테크',
  '설계·엔지니어링': '엔지니어링 서비스업·건축사사무소·건축설계·기술사사무소·측량 — 시공은 건설업',
  관광숙박: '관광숙박업·관광호텔·민박업·여관업·펜션·한옥체험·캠핑장·야영장',
};
/* 옛 이름 — 전용분야 · 업종 전용 칩(2026-10-05f 이전 화면). 엔진이 옛 값을 새 키로 읽으므로 화면은 새 표만 쓴다 */
export const GOV_SECTORS_IND = Object.keys(LEGACY_TO_KEYS).filter((k) => !['예술', '반려동물', '환경', '물산업', '식품', '화장품', '스포츠', '문화', '관광', '핀테크', '서점', '농업', '수산'].includes(k));
export const GOV_SECTORS_STRICT = [...GOV_SPECIAL_Q];
export const GOV_SECTORS = [...GOV_SECTORS_IND, ...GOV_SECTORS_STRICT];
/** 분류 고르기(GovCategoryPicker) 밖에서 따로 다루는 라벨 — 전용 분야 + 기업 유형 + 전용 대상(업종 전용 · 특수 자격) */
export const GOV_SPECIAL = [...GOV_ARTS, ...GOV_TYPES, ...GOV_SECTORS, ...Object.keys(LEGACY_SPECIAL)];

/** 전용 분야·기업 유형 칩의 뜻 (2026-10-03 지도사 「의미를 명확하게 · 고객 등록할 때 놓칠 것 같다」)
 *  sub = 칩 옆 짧은 뜻 · tip = 마우스를 올리면 (포함 / 아님 → 대신 쓸 것) — 엔진(services/govMatch.js) 업종 판정·AI 지시와 같은 기준 */
export const GOV_SPECIAL_INFO: Record<string, { sub: string; tip: string }> = {
  예술: { sub: '작가·단체', tip: '예술인·예술단체만 신청 가능 — 공연·전시·창작. 콘텐츠 기업(영상·게임·출판)은 「문화」' },
  스포츠: { sub: '체육기업', tip: '스포츠·체육 기업만 신청 가능 — 스포츠 산업·용품·시설' },
  식품: { sub: '제조·가공', tip: '식품·식료품 제조·가공 기업만 — HACCP·식품 수출 등.\n음식점·카페는 아님 → 「매장운영」+ 업종 음식점업' },
  환경: { sub: '환경산업', tip: '환경산업 기업만 — 폐기물·재활용·수처리·오염방지·환경 컨설팅.\n일반 기업의 친환경 설비 지원은 아님' },
  문화: { sub: '콘텐츠', tip: '문화콘텐츠 기업만 — 영상·방송·게임·출판·음악·웹툰·캐릭터·공연' },
  화장품: { sub: '제조·판매', tip: '화장품 제조·판매(브랜드·OEM·ODM·원료) 기업만.\n미용실·네일은 아님 → 「매장운영」' },
  농업: { sub: '재배·축산', tip: '농업인·농업법인·영농조합·축산·임업만.\n농산물 가공 기업은 「식품」' },
  수산: { sub: '어업·양식', tip: '어업인·양식·어촌만.\n수산물 가공 기업은 「식품」' },
  관광: { sub: '관광사업체', tip: '관광사업체만 — 여행업·관광숙박·국제회의(MICE)·유원시설·관광 벤처' },
  반려동물: { sub: '연관산업', tip: '반려동물 연관산업만 — 펫푸드·용품·동물병원·미용·위탁.\n가축·축산은 「농업」' },
  물산업: { sub: '상하수도·수처리', tip: '물산업 기업만 — 상하수도·수처리·정수·담수화·물 기기·먹는샘물' },
  핀테크: { sub: '금융혁신', tip: '핀테크 기업만 — 전자금융·간편결제·블록체인·크라우드펀딩·인슈어테크.\n은행·보험대리점은 아님' },
  서점: { sub: '지역서점', tip: '서점·책방만.\n출판사는 「문화」' },
  사회적경제기업: { sub: '사회적기업·협동조합', tip: '사회적기업·예비사회적기업·협동조합·마을기업·자활기업만 (이름에 협동조합·마을기업이 있으면 자동)' },
  여성기업: { sub: '확인서', tip: '여성기업 확인서를 가진 기업만' },
  장애인기업: { sub: '확인서', tip: '장애인기업 확인서를 가진 기업만' },
  뿌리기업: { sub: '확인서', tip: '뿌리기업 확인서를 가진 기업만 (주조·금형·용접·소성가공·표면처리·열처리 등).\n체크하면 「제조업 › 뿌리산업」 공고에도 연결 · 확인서 없이 뿌리기술만 하는 업체는 업종 글로 「제조업 › 뿌리산업」이 자동' },
  소부장기업: { sub: '전문기업', tip: '소재·부품·장비 전문기업 확인을 받은 기업만' },
  '공장등록 업체': { sub: '공장등록증', tip: '공장등록을 필한(공장등록증을 가진) 업체만 — 시설자금 · 기숙사 임차비 · 재해시설자금 등.\n업종으로 알 수 없어 체크한 업체만 해당 · 체크하지 않은 제조업체는 「확인 필요」' },
  // 2026-10-05r 등록 공고 45건(시군 환경 보조금)의 「4·5종 대기배출사업장」 자격
  '대기배출사업장': { sub: '배출시설 신고', tip: '대기환경보전법 대기배출시설 설치 신고·허가를 한 사업장만(1~5종 — 지원은 대개 4·5종 소규모) — IoT 측정기기 부착비 · 노후 방지시설 교체 · 설치비 지원 등.\n업종으로 알 수 없어 체크한 업체만 해당 · 체크하지 않은 제조업체는 「확인 필요」 · 도장·도금·주조·열처리·인쇄·세탁·레미콘처럼 배출시설이 흔한 업종은 확인해 볼 것' },
  '농업법인': { sub: '이름으로 자동', tip: '농업회사법인 · 영농조합법인 · 어업회사법인 · 영어조합법인만(농식품부 · 해수부 법인 전용 사업 · 농업정책자금).\n회사 이름으로 자동 체크(탭하면 빠짐)' },   // 2026-10-07 장수푸드
  매장운영: { sub: '점포·음식점', tip: '오프라인 점포를 운영하는 사업자만 — 음식점·카페·소매점·미용실·전통시장 점포 등.\n온라인·통신판매만 하는 곳은 아님' },
  // 업종 전용 (2026-10-05f) — 포함 / 아님 기준. 업체는 업종·주요 제품 글로 자동 판정(엔진 SECTORS co 규칙)
  소방산업체: { sub: '소방용품·시설업', tip: '소방용품·소방장비 제조, 소방시설업(설계·공사·감리)·방재 기업만.\n소방시설을 «설치하는» 일반 업체 지원은 아님(전 업종 대상)' },
  '원전·에너지 기업': { sub: '원전·전력', tip: '원전 협력·기자재, 원자력, 전력·발전·전기설비 기업만.\n에너지 효율·절감 설비를 «쓰는» 지원은 아님' },
  '신재생에너지 기업': { sub: '태양광·풍력', tip: '태양광·풍력·지열·연료전지·ESS 등 신재생 설비 제조·시공 기업만.\n신재생 설비를 «설치하는» 일반 기업 지원은 아님' },
  '수소 기업': { sub: '수소·연료전지', tip: '수소 생산·저장·충전, 연료전지 기업만 (예비수소전문기업 포함)' },
  방산기업: { sub: '국방·방위산업', tip: '방위산업체·국방 협력기업·군수품 제조 기업만 (국방벤처 협약기업 포함)' },
  '조선·해양 기업': { sub: '조선 기자재', tip: '선박 건조·수리, 조선 기자재, 해양플랜트 기업만' },
  '항공·우주 기업': { sub: '항공부품·우주', tip: '항공 부품·정비, 우주·위성, 드론 제조 기업만' },
  '반도체 기업': { sub: '소부장 포함', tip: '반도체 소재·부품·장비·설계·제조 기업만' },
  '바이오·제약 기업': { sub: '제조·연구개발', tip: '바이오·제약·의약품·백신·진단시약을 만들거나 연구개발하는 기업만 — 제조업 · 연구개발업 › 바이오·제약 (하나라도).\n의료기기 기업 · 의약품 도매는 아님' },
  '의료기기 기업': { sub: '제조·연구개발', tip: '의료기기를 만들거나 연구개발하는 기업만 — 제조업 · 연구개발업 › 의료기기 (하나라도).\n바이오·제약 기업 · 의료기기 도매는 아님' },
  '섬유·패션 기업': { sub: '섬유·의류 제조', tip: '섬유·직물·염색·봉제·의류 제조, 패션 브랜드 기업만' },
  '소비재 기업': { sub: '수출 소비재', tip: '화장품·식품·생활용품·의류·잡화 등 소비재를 만드는 기업만 — K-소비재 수출 사업 등.\n원자재·기계·부품 기업은 아님' },
  '축산 기업': { sub: '농가·법인', tip: '축산업 허가·등록 농가·축산법인(한우·양돈·양계·낙농)만.\n축산물을 «파는» 매장 지원은 아님' },
  '전통주 기업': { sub: '주류 제조', tip: '전통주·막걸리·약주·증류주 등 주류 제조(양조장) 기업만' },
  '전통식품 기업': { sub: '장류·발효·떡', tip: '전통식품 품질인증·장류·김치·떡·한과·발효식품 제조 기업만' },
  // 특수 자격 — 자동 판정 없음(업체에 체크한 경우만 추천)
  '재창업·재도전': { sub: '확인 필요', tip: '폐업 경험이 있는 대표의 재창업(예비 재창업자 포함)만.\n자동으로 알 수 없어 업체에 체크한 경우만 추천 · 「경영위기 소상공인 재기」는 아님' },
  '재해 피해기업': { sub: '피해 확인서', tip: '재난·재해·화재·감염병·통상(관세·중동) 피해를 확인받은 기업만.\n업체에 체크한 경우만 추천' },
  '넷제로 유망기업': { sub: '중진공 지정', tip: '중진공 Net-Zero 유망기업으로 지정된 기업만.\n업체에 체크한 경우만 추천' },
  '사업전환 승인기업': { sub: '중기부 승인', tip: '중소기업 사업전환 촉진법에 따라 사업전환계획 승인을 받은 기업만(사업전환 R&D · 사업전환지원자금 · 구조혁신).\n업체에 체크한 경우만 추천' },
  // 2026-10-07d 필요 자격 — 미리 갖춰야 하는 자격(업체 기본값 미해당 · 체크한 업체만 추천)
  '스마트공장 구축기업': { sub: '기구축', tip: '스마트공장을 이미 구축한 기업만(고도화 · 자율형 공장 · 「중간1 이상」 · 기초 수준 이상 대상).\n업체에 체크한 경우만 추천' },
  '대기업 협력사': { sub: '협력사 추천', tip: '대기업 · 공기업 협력사이거나 그 추천을 받은 기업만(대·중소 상생형 · 협력사 전용).\n업체에 체크한 경우만 추천' },
  '혁신제품 지정기업': { sub: '조달청 지정', tip: '혁신제품 · 우수조달 · 우선구매 대상 기술개발제품으로 지정된 제품을 가진 기업만.\n업체에 체크한 경우만 추천' },
  '백년소상공인': { sub: '중기부 지정', tip: '백년소상공인 · 백년가게 · 백년소공인으로 지정된 업체만.\n업체에 체크한 경우만 추천' },
  '졸업후보기업': { sub: '소진공 선정', tip: '소상공인 졸업후보기업(소상공인 → 중소기업 성장 요건)으로 선정된 기업만.\n업체에 체크한 경우만 추천' },
  '로컬크리에이터': { sub: '선정 기업', tip: '로컬크리에이터로 선정 · 활동 중인 기업만.\n업체에 체크한 경우만 추천' },
  '대학발 창업기업': { sub: '대학 연계', tip: '대학 소속 · 대학 보육 · 대학 기술이전 · 대학 기술지주 투자 창업기업만(창업중심대학 대학발 트랙 등).\n업체에 체크한 경우만 추천' },
  '연구소 보유기업': { sub: '기업부설연구소 · 전담부서', tip: '기업부설연구소 · 연구개발전담부서를 인정받은 기업만(연구인력 채용 · 연구 인턴 지원 등).\n업체에 체크한 경우만 추천' },
  '벤처기업': { sub: '벤처확인', tip: '벤처기업 확인서를 받은 기업만.\n보유 인증에 벤처기업이 있으면 자동' },
  '이노비즈': { sub: '기술혁신형', tip: '이노비즈(기술혁신형 중소기업) 확인 기업만.\n보유 인증에 이노비즈가 있으면 자동' },
  '메인비즈': { sub: '경영혁신형', tip: '메인비즈(경영혁신형 중소기업) 확인 기업만.\n보유 인증에 메인비즈가 있으면 자동' },
  '특허 보유': { sub: '등록 특허', tip: '등록 특허를 보유한 기업만.\n특허 건수가 있으면 자동' },
  '상표권 보유': { sub: '등록 상표', tip: '등록 상표권을 보유한 기업만.\n크레탑 상표권 건수가 있으면 자동 · 0건이면 해당 없음' },
  // 2026-10-08 지도사 「이거 3개는 업체 등록 시 체크할 수 있도록」 — 공고 필수 자격이 이 이름이면 체크한 업체만 통과(안 체크 = 확인 필요)
  '기숙사 임차기업': { sub: '근로자 기숙사', tip: '근로자 기숙사로 아파트 · 빌라 · 오피스텔 등을 임차해 쓰는 기업만(기숙사 임차비 지원).\n업체에 체크한 경우만 추천' },
  '농공단지 입주기업': { sub: '농공단지', tip: '농공단지에 입주(공장 등록)한 기업만(농공단지 물류비 · 입주기업 지원).\n업체에 체크한 경우만 추천' },
  '재단 보증 이용기업': { sub: '신용보증재단', tip: '지역 신용보증재단 보증서 대출을 이용 중인(이용한) 기업만(분할상환 · 갈아타기 특례보증 등).\n업체에 체크한 경우만 추천' },
  '화장품 관련 제조': { sub: '화장품 · 부자재', tip: '화장품 또는 화장품 필수 부자재(용기 · 펌프 · 박스 등)를 만드는 기업만(K-뷰티론 등).\n업종에 화장품이 있는 제조 업체는 자동 · 그 밖은 업체에 체크한 경우만 추천' },
};
/** 제조업 세부 분야 (2026-10-03) — 이름·순서는 엔진(services/govMatch.js MFG_SUBS)과 같아야 한다(backend 테스트가 확인).
 *  공고: 「제조업」 + 세부를 고르면 그 분야 제조업체만. 업체: 업종·주요 제품 글로 자동 판정 — 아래 정규식은 화면 표시용(판정은 서버 엔진) */
export const GOV_MFG_SUBS: [string, RegExp][] = [
  ['반도체·전자', /반도체|전자\s*부품|전자부품|디스플레이|인쇄\s*회로|PCB|센서|광학|LED|통신\s*장비|전자\s*기기|전자기기|웨이퍼|팹리스|가전\s*(제품|기기)|(생활|소형|주방|융\s*복합|스마트|대형)\s*가전|(?<![가-힣])가전(?![가-힣])/i],
  ['이차전지·전기', /이차\s*전지|2차\s*전지|배터리|축전지|양극재|음극재|전해질|전기\s*장비|변압기|전동기|발전기|배전반|전선|케이블/],
  ['자동차·모빌리티', /자동차|차량|모빌리티|자율\s*주행|전기차|이륜|트레일러|타이어/],
  ['조선·선박', /선박|조선|해양\s*플랜트|보트|요트|선체|기자재/],
  ['항공·드론·방산', /항공|드론|무인기|우주|위성|방산|방위|무기|총포|탄약/],
  ['로봇·자동화', /로봇|자동화|스마트\s*팩토리|협동\s*로봇|물류\s*자동화|모션\s*제어|PLC/i],
  ['바이오·제약·의료기기', /바이오|제약|의약|의료\s*기기|의료용|진단|백신|세포|유전자|체외|건강\s*기능/],
  ['화학·소재', /화학|고무|플라스틱|합성\s*수지|소재|도료|접착제|필름|세라믹|유리|탄소\s*(섬유|복합)|복합\s*재|광\s*섬유|인조\s*흑연|석재|레미콘|시멘트|콘크리트\s*(제품|블록|파일|2차)|비금속\s*광물/],
  ['금속·기계', /금속|기계|장비|금형|주물|단조|용접|공작|부품\s*가공|정밀\s*가공|철강|도금|표면\s*처리|열\s*처리|알루미늄|비철|압연|제련|승강기|엘리베이터|에스컬레이터/],
  ['섬유·의류', /(?<!탄소\s?|광\s?|유리\s?)섬유|직물|의복|의류|봉제|원단|가죽|신발|패션/],
  ['에너지·신재생', /에너지|태양광|태양\s*전지|풍력|수소|연료\s*전지|신재생|ESS|발전\s*설비|열\s*교환/i],
];
export const MFG_SUB_NAMES: string[] = GOV_MFG_SUBS.map(([n]) => n);
/** 업종·주요 제품 글 → 해당 제조 세부 분야 (화면 표시용) */
export const mfgSubsOf = (text: string): string[] => (text && text.trim() ? GOV_MFG_SUBS.filter(([, rx]) => rx.test(text)).map(([n]) => n) : []);
/** R&D 공고의 기본 업종 — 업종을 비워 두면 엔진이 이 셋으로 본다 */
export const RND_DEFAULT_BIZ = ['제조업', '연구개발업', 'IT/SW개발업'];
/** 평면 목록(대분류 + 세부, 지도 순서) — 필터 · 통계용. noGroupLabel 대분류명(기타)은 라벨이 아니라 빠진다 */
export const GOV_CATEGORIES: string[] = GOV_TAXONOMY.flatMap((g) => (g.noGroupLabel ? [...g.items] : [g.name, ...g.items]));
/** 옛 라벨 → 새 라벨 — 엔진(govMatch.js LEGACY_CAT)과 같은 목록 (기업 인증은 표기 변형만, 2026-10-01) */
export const LEGACY_CAT: Record<string, string> = { '특허': '특허 출원', '제품인증': '제품 인증', '시제품': '시제품 제작', '고용지원금': '고용', '고용창출지원': '고용 창출', '고용창출': '고용 창출', '고용유지': '고용 유지',
  '마케팅 지원': '마케팅', '마케팅지원': '마케팅', '수출지원': '수출', '창고환경 개선': '매장환경 개선', '전산': '전산 프로그램', '스마트공장': '공장 지능화', '공장안전화': '공장 안전화', '공장자동화': '공장 자동화', '공장지능화': '공장 지능화', '공장안전': '공장 안전화', '공장자동': '공장 자동화', '공장지능': '공장 지능화', '환경개선': '매장환경 개선', '보증': '보증지원',
  '기업인증': '기업 인증' };   // 인증 이름(이노비즈 · 벤처인증 …)은 옮기지 않는다 — 업체 태그에선 「이미 보유」 뜻
/** 옛 라벨 정규화 — 엔진 catCanon 과 같은 규칙(공백 정리 → 그대로 · 공백 뺀 모양 순으로 찾는다) */
export const canonCat = (c: string): string => { const s = c.replace(/\s+/g, ' ').trim(); return LEGACY_CAT[s] || LEGACY_CAT[s.replace(/\s+/g, '')] || s; };
/** 옛 '기타'(분류 미정) — noGroupLabel 대분류명과 같은 글자인 저장값 */
export const isLegacyGroupLabel = (label: string): boolean => GOV_TAXONOMY.some((g) => !!g.noGroupLabel && g.name === label);
export const groupOf = (label: string): GovGroup | undefined => GOV_TAXONOMY.find((g) => g.name === label || g.items.includes(label));
/** 정렬 키 — 지도 순서(대분류 → 세부) · 체계 밖 라벨은 맨 뒤 */
export const catOrder = (label: string): number => {
  const c = canonCat(label);
  for (let gi = 0; gi < GOV_TAXONOMY.length; gi++) {
    const g = GOV_TAXONOMY[gi];
    if (g.name === c) return gi * 100;
    const ii = g.items.indexOf(c);
    if (ii >= 0) return gi * 100 + ii + 1;
  }
  return 9999;
};

interface PickerProps {
  value: string[];                      // 선택된 라벨(대분류 · 세부 섞임)
  onChange: (next: string[]) => void;
  loans?: boolean;                      // 정책자금 묶음 표시 (기본 true)
  compact?: boolean;                    // 업체 매칭 칸용 작은 크기
  colors?: { bd: string; bg: string; fg: string };
}
/** 대분류 헤더(클릭 = 대분류 자체 선택) + 세부 pill — 등록 · 업체 매칭 공용
 *  noGroupLabel 대분류(기타)는 머리 클릭 = 세부 전부 켜기/끄기 — '기타' 자체는 저장하지 않는다 */
export function GovCategoryPicker({ value, onChange, loans = true, compact = false, colors }: PickerProps) {
  const col = colors || { bd: '#5DCAA5', bg: '#E1F5EE', fg: '#085041' };
  const sel = new Set(value.map(canonCat));
  const toggle = (label: string) => { const next = new Set(sel); if (next.has(label)) next.delete(label); else next.add(label); onChange(Array.from(next)); };
  const toggleAll = (items: string[]) => {
    const next = new Set(sel);
    const allOn = items.every((it) => next.has(it));
    items.forEach((it) => { if (allOn) next.delete(it); else next.add(it); });
    onChange(Array.from(next));
  };
  const fs = 11; // 등록 양식의 다른 선택 단추(무관·소상공인 …, Pill 11px)와 같은 크기 — 12px 이면 이 칸만 커 보인다 (2026-10-01)
  return (
    <div style={{ display: 'grid', gridTemplateColumns: compact ? 'repeat(2, minmax(0, 1fr))' : 'repeat(3, minmax(0, 1fr))', gap: compact ? 6 : 8 }}>
      {GOV_TAXONOMY.filter((g) => loans || !g.loan).map((g) => {
        const bare = !!g.noGroupLabel;                                         // 기타 — 머리는 묶음 제목(세부 전부 토글)
        const legacyOn = bare && sel.has(g.name);                              // 옛 '기타'(분류 미정) 값이 남아 있음
        const gOn = bare ? g.items.every((it) => sel.has(it)) : sel.has(g.name);
        const anyItem = g.items.some((it) => sel.has(it));
        const lockItems = gOn && !bare;                                        // 대분류 자체 선택일 때만 세부 잠금
        return (
          <div key={g.k} style={{ border: `1px solid ${gOn || anyItem ? col.bd : '#E5E7EB'}`, borderRadius: 8, padding: compact ? '6px 8px' : '8px 10px', background: gOn ? col.bg : '#fff' }}>
            <button type="button" onClick={() => (bare ? toggleAll(g.items) : toggle(g.name))}
              title={bare ? `「${g.name}」 세부(${g.items.join(' · ')}) 전부 선택` : `대분류 「${g.name}」 자체를 선택 — 세부가 애매할 때`}
              style={{ display: 'flex', alignItems: 'center', gap: 6, width: '100%', border: 'none', background: 'none', padding: 0, cursor: 'pointer', fontSize: fs + 1, fontWeight: 700, color: gOn ? col.fg : '#374151', textAlign: 'left' }}>
              <span style={{ width: 14, height: 14, borderRadius: 3, border: `1.5px solid ${gOn ? col.fg : '#9CA3AF'}`, background: gOn ? col.fg : '#fff', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: 10, flex: 'none' }}>{gOn ? '✓' : ''}</span>
              {g.name}{g.loan || bare ? '' : ' 전체'}
            </button>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, marginTop: 6 }}>
              {g.items.map((it) => {
                const on = sel.has(it) || lockItems;
                return (
                  <button key={it} type="button" onClick={() => toggle(it)} disabled={lockItems}
                    style={{ padding: compact ? '2px 7px' : '4px 10px', borderRadius: 999, fontSize: fs, fontWeight: on ? 700 : 500, cursor: lockItems ? 'default' : 'pointer',
                      border: `1px solid ${on ? col.bd : '#E5E7EB'}`, background: on ? col.bg : '#fff', color: on ? col.fg : '#4B5563', opacity: lockItems && !sel.has(it) ? 0.75 : 1 }}>{it}</button>
                );
              })}
              {legacyOn && (
                <button type="button" onClick={() => toggle(g.name)} title="예전에 저장된 '기타'(분류 미정) — 「기업 인증」과는 매칭되지 않습니다. 클릭하면 지웁니다"
                  style={{ padding: compact ? '2px 7px' : '3px 9px', borderRadius: 999, fontSize: fs, fontWeight: 600, cursor: 'pointer',
                    border: '1px dashed #D1D5DB', background: '#F9FAFB', color: '#6B7280' }}>옛 분류 「{g.name}」 ✕</button>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
